// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
// ── Sellers ──────────────────────────────────────────────────────
export const SELLER_REGISTRATION_STATUSES = [
    'draft',
    'submitted',
    'verified',
    'rejected',
    'suspended',
    'withdrawn',
];
export const DOCUMENT_EVIDENCE_STATUSES = ['recorded', 'issued', 'cancelled', 'replaced'];
// ── Reconciliation ───────────────────────────────────────────────
export const RECONCILIATION_RUN_STATUSES = ['running', 'complete', 'failed'];
export const RECONCILIATION_EXCEPTION_STATUSES = [
    'open',
    'under_review',
    'resolved',
    'accepted',
];
// ── Authority correspondence ─────────────────────────────────────
export const CORRESPONDENCE_STATUSES = [
    'open',
    'evidence_assembled',
    'responded',
    'closed',
];
/**
 * The statuses from which a record may still gain evidence or an answer.
 *
 * A strict subset of `CORRESPONDENCE_STATUSES`, not a second vocabulary — every
 * member is declared above, and `status-reachability.test.ts` asserts that
 * relation rather than measuring this list for reachability of its own.
 *
 * It lives in the shared contract because **two surfaces enforce the same
 * boundary and must read one declaration**. The server is the enforcement:
 * `AuthorityCorrespondenceService.assertStillOpen` refuses `assemble` and
 * `respond` outside this set with a 409, and `respond`'s compare-and-set filters
 * on it so two concurrent answers cannot both record themselves as the one
 * given. The register page is the affordance: it hides the two row controls
 * outside this set, so an operator is not offered a button whose only possible
 * outcome is that 409 — which is what the shipped page did, on every answered
 * record.
 *
 * Declared here rather than in the service — where it was, unexported from
 * `@vn-grc/shared` and so unreadable by the frontend — precisely so the
 * affordance cannot drift from the enforcement. Hiding a control the server
 * would refuse is an affordance and never the enforcement; the route gate is
 * unchanged.
 *
 * Note it contains `evidence_assembled`: re-assembling an already-assembled
 * record is legal, and a reader who assumes "assembled ⇒ done" would remove a
 * working capability.
 */
export const CORRESPONDENCE_OPEN_STATUSES = ['open', 'evidence_assembled'];
// ── Collections ──────────────────────────────────────────────────
export const PLATFORM_SELLER_COLLECTION = 'grc_platform_sellers';
export const PLATFORM_TRANSACTION_COLLECTION = 'grc_platform_transaction_records';
export const PLATFORM_DOCUMENT_COLLECTION = 'grc_platform_document_evidence';
export const RECONCILIATION_RUN_COLLECTION = 'grc_platform_reconciliation_runs';
export const RECONCILIATION_EXCEPTION_COLLECTION = 'grc_platform_reconciliation_exceptions';
export const AUTHORITY_CORRESPONDENCE_COLLECTION = 'grc_platform_authority_correspondence';
//# sourceMappingURL=platform-evidence.js.map